module.exports = __webpack_public_path__ + "img/everything_zoomed_out.c201f301.png";